<template>
  <v-tabs ref="tabs" color="nx-primary--darken-2">
    <v-tab
      :class="{ 'tab-active': activeTab === 1 }"
      @click="toggleActive(1)"
      :to="{
        name: 'composition.editor',
        params: {
          compositionId: id,
          compositionRelativeVersionId,
        },
        exact: true
      }"
    >
      {{ $t('message.board.breadcrumbs.edition') }}
    </v-tab>
    <v-tab
      :class="{ 'tab-active': activeTab === 2 }"
      @click="toggleActive(2)"
      :to="{
        name: 'composition.metadata',
        params: { id },
        exact: true
      }"
    >
      {{ $t('message.board.breadcrumbs.metadata') }}
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  props: {
    id: Number,
    compositionRelativeVersionId: Number,
  },
  data() {
    return {
      activeTab: 1,
    };
  },
  methods: {
    toggleActive(tab) {
      this.activeTab = tab;
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$route.name.includes('composition.metadata')) this.activeTab = 2;
    });
  },
};
</script>

<style>
.tab-active .v-tabs__item--active {
  border-bottom: solid #1DE9B6 3px;
}
</style>
